var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{ref:"svg",staticStyle:{"width":"100%","height":"210px","margin-bottom":"10px"},attrs:{"v":"","id":"listeners"}})])}
var staticRenderFns = []

export { render, staticRenderFns }